import mountLoadingSpinner from 'Component/LoadingSpinner';
import {
    BENEFITS_HARDWARE_ONLY_FALSE_CONTAINER_ID,
    BENEFITS_HARDWARE_ONLY_TRUE_CONTAINER_ID,
    BENEFITS_PAYMENT_MONTHLY_CONTAINER_ID,
    BENEFITS_PAYMENT_ONETIME_CONTAINER_ID,
    DELIVERY_DATE_CONTAINER_ID,
    IMAGE_GALLERY_CONTAINER_ID,
    LOADING_CONTAINER,
    OFFER_SUMMARY_CARD_CONTAINER_ID,
    OPTION_PICKER_CASE_SIZE_CONTAINER_ID,
    OPTION_PICKER_COLOR_CONTAINER_ID,
    OPTION_PICKER_HARDWARE_ONLY_CONTAINER_ID,
    OPTION_PICKER_PAYMENT_CONTAINER_ID,
    STICKY_PRICE_BAR_CONTAINER_ID,
    TECHNICAL_DETAILS_ACCORDION_CONTAINER_ID,
    TEXT_HEADER_CONTAINER_ID,
} from 'Container/App/constants';
import { selectCustomerConfig } from 'Container/App/selectors';
import getCustomerConfig from 'Container/App/helpers/getCustomerConfig';
import mountTextHeader from 'Component/TextHeader';
import mountIconText from 'Component/IconText';
import mountColorOptionPicker from 'Component/ColorPicker';
import mountCaseSizeOptionPicker from 'Component/CaseSizePicker';
import mountHardwareOnlyPicker from 'Component/HardwareOnlyPicker';
import mountPaymentPicker from 'Component/PaymentPicker';
import { PriceType } from '@vfde-sails/glados-v2';
import mountOfferSummaryCard from 'Component/OfferSummaryCard';
import { mountEditorialAccordions } from 'Component/Accordion';
import prepareTechnicalDetailsAccordion from 'Component/TechnicalDetailsAccordion';
import {
    createUnorderedVerticalList,
    UNORDERED_VERTICAL_LIST_BASE_CLASSNAME,
} from '@vfde-brix/ws10/unordered-vertical-list';
import {
    createComponents,
    NO_PATTERN_BUSINESS_LOGIC,
    toggleElementVisibility,
} from '@vfde-brix/ws10/core';
import {
    mountBeltContainerForApp,
    mountBeltContainerForError,
} from 'Component/BeltContainer';
import { useDispatch } from '../../store';
import { setInitialState } from 'Container/App/slice';
import prepareImageGallery from 'Component/ImageGallery';
import { startAppListening } from 'Container/App/listener';

const mountStoneDdpAppContainer = () => {
    const dispatch = useDispatch();

    const customerConfig = getCustomerConfig();

    mountBeltContainerForApp();
    mountBeltContainerForError();
    mountLoadingSpinner(LOADING_CONTAINER);
    mountTextHeader(TEXT_HEADER_CONTAINER_ID);
    mountIconText(DELIVERY_DATE_CONTAINER_ID);
    mountColorOptionPicker(OPTION_PICKER_COLOR_CONTAINER_ID);
    mountCaseSizeOptionPicker(OPTION_PICKER_CASE_SIZE_CONTAINER_ID);
    mountPaymentPicker(OPTION_PICKER_PAYMENT_CONTAINER_ID, customerConfig);
    mountHardwareOnlyPicker(
        OPTION_PICKER_HARDWARE_ONLY_CONTAINER_ID,
        customerConfig,
    );
    mountOfferSummaryCard(OFFER_SUMMARY_CARD_CONTAINER_ID, STICKY_PRICE_BAR_CONTAINER_ID);
    prepareImageGallery(IMAGE_GALLERY_CONTAINER_ID);
    prepareTechnicalDetailsAccordion();

    // Mount all editorial accordions at once, except hardware-details-accordion, because that is mounted and used by code)
    mountEditorialAccordions([TECHNICAL_DETAILS_ACCORDION_CONTAINER_ID]);

    // Mount the unordered vertical list just for the sake of the tooltip within it...
    createComponents(`.${UNORDERED_VERTICAL_LIST_BASE_CLASSNAME}`, createUnorderedVerticalList, NO_PATTERN_BUSINESS_LOGIC);

    // Stupid HTML stuff
    const hardwareOnlyFalse = document.getElementById(BENEFITS_HARDWARE_ONLY_FALSE_CONTAINER_ID);
    const hardwareOnlyTrue = document.getElementById(BENEFITS_HARDWARE_ONLY_TRUE_CONTAINER_ID);
    const paymentMethodMonthly = document.getElementById(BENEFITS_PAYMENT_MONTHLY_CONTAINER_ID);
    const paymentMethodOnetime = document.getElementById(BENEFITS_PAYMENT_ONETIME_CONTAINER_ID);
    startAppListening({
        predicate: (action, currentState, previousState) => {
            const newState = selectCustomerConfig(currentState);
            const oldState = selectCustomerConfig(previousState);

            return newState.isHardwareOnly !== oldState.isHardwareOnly
                || newState.paymentMethod !== oldState.paymentMethod;
        },
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const newState = selectCustomerConfig(listenerApi.getState());

            hardwareOnlyFalse && toggleElementVisibility(hardwareOnlyFalse, !newState.isHardwareOnly);
            hardwareOnlyTrue && toggleElementVisibility(hardwareOnlyTrue, newState.isHardwareOnly);

            paymentMethodMonthly && toggleElementVisibility(
                paymentMethodMonthly,
                newState.paymentMethod !== undefined
                && !newState.isHardwareOnly
                && newState.paymentMethod === PriceType.Monthly,
            );

            paymentMethodOnetime && toggleElementVisibility(
                paymentMethodOnetime,
                newState.paymentMethod !== undefined
                && !newState.isHardwareOnly
                && newState.paymentMethod === PriceType.Onetime,
            );
        },
    });

    dispatch(setInitialState(customerConfig));
};

export default mountStoneDdpAppContainer;
